import { ErrorData } from "../component/error-message-popper";

type Listener = (error: ErrorData) => void;
type ActionCallback = () => void;

class ErrorService {
    private listeners: Listener[] = [];
    private actionCallback?: ActionCallback | null = null;
    private isOpen = false;

    subscribe(listener: Listener) {
        this.listeners.push(listener);
        return () => {
            this.listeners = this.listeners.filter((l) => l !== listener);
        };
    }

    showError(error: ErrorData) {
        this.setPopupOpen(true);
        this.listeners.forEach((listener) => listener(error));
    }

    setActionCallback(callback: ActionCallback | null) {
        this.actionCallback = callback;
    }

    executeAction() {
        if (this.actionCallback) {
            this.actionCallback();
            this.actionCallback = null;
        }
    }

    setPopupOpen(isOpen: boolean) {
        this.isOpen = isOpen;
    }

    isPopupOpen() {
        return this.isOpen;
    }
}

const errorService = new ErrorService();
export default errorService;
